import React, { Component } from 'react';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';


export class VkAuthPage extends React.Component {

    constructor(props) {
        super(props);
        
    }
    render() {
        return (
          <div className="createPage_whiteBlock whiteBlock">
            <div className='whiteBlockTitle'>
            <BeautifulCircleIcon/>
                <div className='whiteBlockTitleSpan'>
                    Выберите название  для создаваемого виджета
                </div>
            </div>
            {/*<div className='editBlock'>
                <a target="_blank" className='btn1' href='https://oauth.vk.com/authorize?client_id=8139344&redirect_uri=http://clientsaver.ru/callback&scope=262144&display=page'>
                    Авторизоваться через вк
                </a>
              </div>*/}


            <div className="whiteBlockMiddle">
                   
                        <div className='whiteBlockTextInputBlock'>
                            <div className='whiteBlockTextInputBlock_label'>
                                Название
                            </div>
                            
                            <input onChange={e => this.props.updateWidgetNameVk(e) } type='text' 
                             value={this.props.data.widget_name} />
                        {/* />*/}
                        </div>
                        

                        <div className='whiteBlockButtonBlock'>
                            <a className="whiteBlockButton" href={process.env.REACT_APP_VK_AUTH_LINK}> Авторизоваться через вк</a>
                        </div>
            </div>           
        </div>         
        )
    }
}